<template>
    <div :class="`edit_profile_bio_box ${type}`">
        <img :src="`/bubble/${type}-tail.svg`" class="edit_profile_bio__tail" loading="lazy" />
        <!-- <img v-if="type === 'default'" src="/edit_tail.svg" class="edit_taill"> -->
        <img src="/about_me.svg" alt="about me" class="about_me_icon" loading="lazy">
        <div class="edit_profile__bio_count">{{ wordCount }} / 170</div>
        <textarea v-model="textarea" @input="filterTextarea" placeholder="Bio" class="edit_profile__bio"></textarea>
    </div>
</template>

<script>
import { ref, computed, watch } from 'vue';

export default {
    name: "BubbleInput",
    props: {
        about_me: {
            type: String,
            default: ""
        },
        type: {
            type: String,
            default: 'simpleBubbleFill'
        }
    },
    emits: ['update:about_me'],
    setup(props, { emit }) {
        const textarea = ref(props.about_me);

        watch(() => props.about_me, (newVal) => {
            textarea.value = newVal;
        });

        watch(textarea, (newVal) => {
            emit('update:about_me', newVal);
        });

        const wordCount = computed(() => {
            return textarea.value?.length ?? 0;
        });

        return { textarea, wordCount };
    },
    methods: {
        filterTextarea: function () {
            const limit = 4

            const lines = this.textarea.split("\n")

            if (lines.length > limit) {
                this.textarea = lines.slice(0, limit).join("\n")
            }

            if (this.textarea.length > 170) {
                this.textarea = this.textarea.slice(0, 170);
            }
        },
    }
}
</script>


<style>
.edit_profile_bio_box {
    position: relative;
    width: fit-content;
    justify-content: center;
    margin-top: 14px;
    max-width: 970px;
    min-height: 50px;
    max-height: 150px;
    height: fit-content;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
}

.bubble_profile p {
    padding: 10px 20px !important;
    min-width: 0 !important;
    text-transform: uppercase;
    display: flex;
    align-items: center;
}

.edit_profile__outline {
    position: absolute;
    background-color: rgba(255, 255, 255, 0);
}

.edit_profile__bio {
    background-color: rgba(255, 255, 255, 0);
    box-sizing: border-box;
    width: fit-content;
    field-sizing: content;
    font-size: 14px;
    font-weight: 400;
    padding: 17px 100px 15px 50px;
    position: relative;
    resize: none;
    max-width: 970px;
    min-height: 50px;
    max-height: 150px;
    min-width: 200px;
    text-transform: uppercase;
    font-family: 'COMIXON';
}

.edit_profile__bio::placeholder {
    color: white;
}

.about_me_icon {
    position: absolute;
    top: 33%;
    left: 17px;
    z-index: 2;
}

.edit_profile__bio_count {
    font-size: 14px;
    position: absolute;
    top: 30%;
    right: 25px;
    color: rgba(255, 255, 255, 0.9);
}

.simpleBubble {
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
}

.simpleBubble .edit_profile__bio {
    color: white;
    border-radius: 10px;
}

.simpleBubble .edit_profile_bio__tail {
    position: absolute;
    top: -11px;
    left: 33px;
}

.simpleBubbleFill {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 10px;
}

.simpleBubbleFill .edit_profile__bio {
    color: black;
    border-radius: 10px;
}

.simpleBubbleFill .edit_profile__bio::placeholder {
    color: rgb(48, 48, 48);
}

.simpleBubbleFill .edit_profile__bio_count {
    color: rgb(48, 48, 48);
    top: 28%;
}

.simpleBubbleFill .about_me_icon {
    background: rgb(48, 48, 48);
    border-radius: 5px;
    padding: 2px;
    top: 30%;
}

.simpleBubbleFill .edit_profile_bio__tail {
    position: absolute;
    top: -11px;
    left: 33px;
}

.dottedBubble {
    background-color: rgba(255, 130, 40, 1);
    color: white;
    border-radius: 10px;
}


.dottedBubble::after {
    content: '';
    position: absolute;
    border-radius: 10px;
    top: 2px;
    left: 2px;
    border: 2px dashed black;
    pointer-events: none;
    width: 100%;
    height: 100%;
    z-index: 1;
}

.dottedBubble .edit_profile__bio {
    border-radius: 10px;
    font-family: 'COMIXON';
    color: black !important;
}

.dottedBubble .edit_profile_bio__tail {
    position: absolute;
    top: -13px;
    left: 37px;
    z-index: 3;
}

.dottedBubble .edit_profile__bio_count {
    color: #000;
}

.rectangleBubble {
    background-color: rgb(255, 255, 255);
}

.rectangleBubble .edit_profile__bio {
    color: black;
    font-family: 'COMIXON';
}

.rectangleBubble .edit_profile__bio::placeholder {
    color: rgb(48, 48, 48);
}

.rectangleBubble .edit_profile__bio_count {
    color: rgb(48, 48, 48) !important;
}

.rectangleBubble .about_me_icon {
    background: rgb(48, 48, 48);
    border-radius: 5px;
    padding: 2px;
    top: 30%;
}

.rectangleBubble::before {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    border: 2px solid black;
    pointer-events: none;
    width: 100%;
    height: 100%;
    z-index: 1;
}

.rectangleBubble::after {
    content: '';
    position: absolute;
    transform: rotate(-20deg);
    left: 31px;
    top: -10px;
    border: 10px solid;
    border-color: transparent white white transparent;
    z-index: -1;
}

.rectangleBubble .edit_profile_bio__tail {
    position: absolute;
    top: -13px;
    left: 37px;
    z-index: 3;
}

.agessiveBubble {
    padding: 0;
    margin-top: 15px;
    margin-left: 20px;
    height: fit-content;
    min-height: 0;
}

.agessiveBubble::before {
    content: "";
    position: absolute;
    top: -1px;
    width: 100%;
    padding: 3px 19px;
    height: 100%;
    z-index: -1;
    border-image: url('/bubble/agessiveBubble-bg.svg') 50% / 45px round;
}

.agessiveBubble .edit_profile__bio {
    max-width: 900px;
    color: white;
    font-family: 'COMIXON';
    background-color: rgba(119, 104, 255, 1);
    border-top: 2px solid white;
    border-bottom: 2px solid white;
    min-height: 0;
    padding: 10px 100px 10px 50px;
}

.agessiveBubble .edit_profile_bio__tail {
    position: absolute;
    top: -14px;
    left: 15px;
    z-index: 3;
}

.agessiveBubble .about_me_icon {
    position: absolute;
    top: 28%;
    left: 13px;
    z-index: 5;
}

.agessiveBubble .edit_profile__bio_count {
    top: 20%;
    color: white;
    z-index: 3;
}


.pixelBubble {
    background-color: rgba(255, 119, 61, 1);
    margin-top: 26px;
    margin-left: 10px;
    min-height: 0;
    box-shadow:
        0 -5px 0 rgba(255, 119, 61, 1),
        0 -10px 0 #000,
        -5px 0 0 rgba(255, 119, 61, 1),
        -10px 0 0 #000,
        0 5px 0 rgba(255, 119, 61, 1),
        0 10px 0 #000,
        5px 0 0 rgba(255, 119, 61, 1),
        10px 0 0 #000,
        -5px -5px 0 #000,
        5px 5px 0 #000,
        -5px 5px 0 #000,
        5px -5px 0 #000;
}

.pixelBubble .edit_profile__bio {
    font-family: "Pixel";
    font-size: 10px;
    padding: 10px 100px 10px 50px;
    min-height: 0;
    color: black !important;
}

.pixelBubble .edit_profile__bio::placeholder {
    color: #777;
}

.pixelBubble .about_me_icon {
    position: absolute;
    top: 28%;
    left: 13px;
    z-index: 5;
}

.pixelBubble .edit_profile__bio_count {
    top: 18%;
    color: black;
}

.pixelBubble .edit_profile_bio__tail {
    position: absolute;
    top: -25px;
    left: 22px;
    z-index: 3;
}

.cloudBubble {
    border-style: solid;
    border-color: transparent;
    border-width: 15px;
    border-image-source: url('/bubble/cloud-bg.svg');
    border-image-slice: 13;
    border-image-repeat: round;
    background-color: transparent;
    margin-top: 20px;
    padding: 0;
    margin-top: 20px;
    height: fit-content;
}

.cloudBubble .edit_profile_bio__tail {
    position: absolute;
    top: -32px;
    left: 30px;
    z-index: -1;
    width: 24px;
    height: 24px;
}

.cloudBubble .edit_profile__bio_count {
    color: black;
    top: 16%;
    z-index: 3;
}

.cloudBubble .about_me_icon {
    top: 20%;
}

.cloudBubble .edit_profile__bio {
    background-color: rgba(236, 41, 41, 1) !important;
    border: none;
    box-shadow: none;
    min-width: 0 !important;
    padding: 8px 100px 8px 50px;
    min-height: 0px;
    color: black !important;
    font-family: 'COMIXON';
}

.kindBubble {
    background-color: rgba(255, 204, 0, 1);
    border-radius: 100px;
    box-shadow: 10px 10px 0 rgba(0, 0, 0, 0.3);
    margin-top: 22px;
}

.kindBubble .edit_profile__bio_count {
    color: black;
}

.kindBubble .edit_profile__bio {
    border-radius: 100px;
    color: black !important;
    font-family: 'COMIXON';
}

.kindBubble .edit_profile__bio::placeholder {
    color: black;
}

.kindBubble .edit_profile_bio__tail {
    position: absolute;
    top: -22px;
    left: 44px;
    z-index: -1;
}

.barbedBubble {
    border: 15px solid transparent;
    border-image-source: url('/bubble/barbedBubble-bg.svg');
    border-image-slice: 30;
    border-image-width: 30px;
    border-image-repeat: round;
    margin-top: 5px;
    padding-top: 15px;
    padding-right: 15px;
    padding-bottom: 10px;
}

.barbedBubble .edit_profile__bio {
    color: black !important;
    font-family: 'COMIXON';
    background: #ffffff;
    min-height: 40px;
    padding: 13px 100px 0px 50px;
}

.barbedBubble .edit_profile_bio__tail {
    display: none;
    position: absolute;
    top: -16px;
    left: 15px;
    z-index: -1;
}

.barbedBubble .about_me_icon {
    position: absolute;
    background-color: black;
    padding: 2px;
    border-radius: 5px;
    top: 40%;
}

.barbedBubble .edit_profile__bio_count {
    top: 40%;
    color: black;
    z-index: 3;
}
</style>
